import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FiCheckCircle, FiMail, FiShield, FiArrowLeft, FiCreditCard, FiStar } from 'react-icons/fi';

const PostRegistration = () => {
    const location = useLocation();
    const state = location.state || {};

    // Datos del state pasados desde el checkout o registro
    const isPaid = state.isPaid || false;
    const planName = state.planName || 'Prueba Gratis';
    const billingCycle = state.billingCycle || '';
    const amount = state.amount || 0;
    const email = state.email || '';
    const empresaNombre = state.empresaNombre || '';

    const formatCLP = (val) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(val);

    return (
        <div style={{
            minHeight: 'calc(100vh - 70px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '40px 20px',
            background: 'linear-gradient(165deg, #0f0c29 0%, #1a1040 25%, #302b63 50%, #24243e 75%, #1a1040 100%)',
            position: 'relative', overflow: 'hidden'
        }}>
            {/* Background decorative elements */}
            <div style={{
                position: 'absolute', top: '10%', left: '5%', width: '300px', height: '300px',
                background: 'radial-gradient(circle, rgba(79,70,229,0.15) 0%, transparent 70%)',
                borderRadius: '50%', filter: 'blur(60px)', pointerEvents: 'none'
            }}></div>
            <div style={{
                position: 'absolute', bottom: '10%', right: '10%', width: '400px', height: '400px',
                background: 'radial-gradient(circle, rgba(236,72,153,0.12) 0%, transparent 70%)',
                borderRadius: '50%', filter: 'blur(80px)', pointerEvents: 'none'
            }}></div>

            <div style={{
                maxWidth: '560px', width: '100%', position: 'relative', zIndex: 1,
                animation: 'fadeInUp 0.6s ease-out'
            }}>
                {/* Main Card */}
                <div style={{
                    background: 'rgba(255,255,255,0.04)',
                    backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '20px', overflow: 'hidden',
                    boxShadow: '0 25px 80px rgba(0,0,0,0.4), 0 0 60px rgba(79,70,229,0.08)'
                }}>
                    {/* Success Icon + Title */}
                    <div style={{ padding: '40px 36px 24px', textAlign: 'center' }}>
                        <div style={{
                            width: '80px', height: '80px', borderRadius: '50%',
                            background: 'linear-gradient(135deg, #10b981, #059669)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 20px',
                            boxShadow: '0 12px 40px rgba(16,185,129,0.35), 0 0 20px rgba(16,185,129,0.15)',
                            animation: 'pulseGlow 2s ease-in-out infinite'
                        }}>
                            <FiCheckCircle size={40} color="white" />
                        </div>

                        <h1 style={{
                            fontSize: '1.8rem', fontWeight: 800, margin: '0 0 8px',
                            background: 'linear-gradient(135deg, #ffffff, #e0e7ff)',
                            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text', letterSpacing: '-0.02em'
                        }}>
                            {isPaid ? '¡Pago Exitoso!' : '¡Registro Exitoso!'}
                        </h1>
                        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.95rem', margin: 0 }}>
                            {isPaid
                                ? 'Tu suscripción ha sido activada correctamente'
                                : 'Tu cuenta de prueba gratuita ha sido creada'
                            }
                        </p>
                    </div>

                    {/* Divider */}
                    <div style={{
                        height: '1px', margin: '0 36px',
                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)'
                    }}></div>

                    {/* Summary Section */}
                    <div style={{ padding: '24px 36px' }}>
                        {/* Plan Info */}
                        <div style={{
                            background: 'rgba(255,255,255,0.04)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            borderRadius: '14px', padding: '18px 20px', marginBottom: '16px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                                <div style={{
                                    width: '38px', height: '38px', borderRadius: '10px',
                                    background: isPaid
                                        ? 'linear-gradient(135deg, #4f46e5, #7c3aed)'
                                        : 'linear-gradient(135deg, #10b981, #059669)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    boxShadow: isPaid
                                        ? '0 4px 15px rgba(79,70,229,0.3)'
                                        : '0 4px 15px rgba(16,185,129,0.3)'
                                }}>
                                    {isPaid ? <FiCreditCard size={18} color="white" /> : <FiStar size={18} color="white" />}
                                </div>
                                <div>
                                    <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.4)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        {isPaid ? 'Plan Contratado' : 'Plan Activado'}
                                    </div>
                                    <div style={{ fontSize: '1rem', fontWeight: 700, color: 'white' }}>
                                        {planName}
                                    </div>
                                </div>
                                {isPaid && amount > 0 && (
                                    <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                                        <div style={{
                                            fontSize: '1.1rem', fontWeight: 800,
                                            background: 'linear-gradient(135deg, #a78bfa, #ec4899)',
                                            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text'
                                        }}>
                                            {formatCLP(amount)}
                                        </div>
                                        <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.35)' }}>
                                            Facturación Anual
                                        </div>
                                    </div>
                                )}
                            </div>

                            {empresaNombre && (
                                <div style={{
                                    borderTop: '1px solid rgba(255,255,255,0.06)',
                                    paddingTop: '10px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)',
                                    display: 'flex', justifyContent: 'space-between'
                                }}>
                                    <span>Empresa</span>
                                    <span style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>{empresaNombre}</span>
                                </div>
                            )}
                        </div>

                        {/* Email Verification Box */}
                        <div style={{
                            background: 'linear-gradient(135deg, rgba(79,70,229,0.1), rgba(124,58,237,0.08))',
                            border: '1px solid rgba(79,70,229,0.2)',
                            borderRadius: '14px', padding: '20px',
                            position: 'relative', overflow: 'hidden'
                        }}>
                            {/* Subtle glow */}
                            <div style={{
                                position: 'absolute', top: '-20px', right: '-20px',
                                width: '80px', height: '80px', borderRadius: '50%',
                                background: 'rgba(79,70,229,0.15)', filter: 'blur(20px)',
                                pointerEvents: 'none'
                            }}></div>

                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', position: 'relative' }}>
                                <div style={{
                                    width: '42px', height: '42px', minWidth: '42px', borderRadius: '12px',
                                    background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    boxShadow: '0 6px 20px rgba(79,70,229,0.3)'
                                }}>
                                    <FiMail size={20} color="white" />
                                </div>
                                <div>
                                    <h3 style={{
                                        fontSize: '0.95rem', fontWeight: 700, color: 'white',
                                        margin: '0 0 6px'
                                    }}>
                                        Verifica tu correo electrónico
                                    </h3>
                                    <p style={{
                                        fontSize: '0.85rem', color: 'rgba(255,255,255,0.55)',
                                        margin: '0 0 10px', lineHeight: '1.5'
                                    }}>
                                        Hemos enviado un código de verificación a tu correo electrónico
                                        {email && <strong style={{ color: 'rgba(255,255,255,0.8)' }}> {email}</strong>}.
                                        Revisa tu bandeja de entrada para activar tu cuenta.
                                    </p>
                                    <div style={{
                                        display: 'flex', alignItems: 'center', gap: '6px',
                                        fontSize: '0.75rem', color: 'rgba(255,255,255,0.35)'
                                    }}>
                                        <FiShield size={12} />
                                        <span>El código expira en 24 horas</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Divider */}
                    <div style={{
                        height: '1px', margin: '0 36px',
                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)'
                    }}></div>

                    {/* Action Button */}
                    <div style={{ padding: '24px 36px 32px', textAlign: 'center' }}>
                        <Link to="/" style={{
                            display: 'inline-flex', alignItems: 'center', gap: '10px',
                            padding: '14px 32px', borderRadius: '12px',
                            background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                            color: 'white', textDecoration: 'none',
                            fontSize: '0.95rem', fontWeight: 600,
                            boxShadow: '0 8px 30px rgba(79,70,229,0.35), 0 0 15px rgba(79,70,229,0.1)',
                            transition: 'all 0.3s ease',
                            letterSpacing: '0.3px'
                        }}
                            onMouseEnter={e => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 12px 40px rgba(79,70,229,0.45), 0 0 20px rgba(79,70,229,0.2)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 30px rgba(79,70,229,0.35), 0 0 15px rgba(79,70,229,0.1)';
                            }}>
                            <FiArrowLeft size={18} />
                            Volver al Inicio
                        </Link>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes pulseGlow {
                    0%, 100% { box-shadow: 0 12px 40px rgba(16,185,129,0.35), 0 0 20px rgba(16,185,129,0.15); }
                    50% { box-shadow: 0 12px 50px rgba(16,185,129,0.5), 0 0 30px rgba(16,185,129,0.25); }
                }
            `}</style>
        </div>
    );
};

export default PostRegistration;
